<div class="card" *ngIf="!useAsInlineField; else tagsField">
  <div class="card-header">
    <h1>
      <span>{{ 'fwTags.header' | translate }}</span>
      <fw-action-menu *ngIf="displayActionMenu" [auditable]="container" [fieldLabel]="'fwTags.header' | translate" fieldKey="tags"></fw-action-menu>
    </h1>
  </div>
  <div *ngIf="!hasTags" class="blank-state">
    <mat-icon class="sm raised blue">local_offer</mat-icon>
    <p>{{ 'fwTags.empty' | translate }}</p>
  </div>
  <ng-container *ngTemplateOutlet="tagsField"></ng-container>
</div>

<ng-template #tagsField>
  <mat-chip-listbox *ngIf="hasTags && !canModifyTags" aria-label="Query field value">
    <mat-chip-option class="chip" *ngFor="let value of form.controls.chips.value; index as tabIndex">{{ value }}</mat-chip-option>
  </mat-chip-listbox>

  <div [formGroup]="form" *ngIf="canModifyTags">
    <mat-form-field class="chip-field">
      <mat-chip-grid #chipList formControlName="chips" aria-label="Query field value">
        <mat-chip-row
          class="chip chip-icon"
          *ngFor="let value of form.controls.chips.value; index as tabIndex"
          (removed)="removeTag(tabIndex)">
          {{ value }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>

        <input
          #chipInput
          style="padding: 6px 0;"
          placeholder="{{ 'fwTags.inputLabel' | translate }}"
          [attr.test-id]="'fw-tag-input'"
          formControlName="text"
          (click)="filterAutocomplete()"
          (focus)="filterAutocomplete()"
          (keyup)="filterAutocomplete()"
          [matAutocomplete]="autoComplete"
          [matChipInputFor]="chipList"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="addTag($event)">

        <mat-autocomplete
          test-id="fw-tags-display-autocomplete"
          #autoComplete="matAutocomplete"
          (optionSelected)="addTag($event)"
          panelWidth="auto">
          <mat-option
            *ngFor="let suggestion of suggestedTags"
            [value]="suggestion">
            {{ suggestion }}
          </mat-option>
        </mat-autocomplete>

      </mat-chip-grid>
    </mat-form-field>
  </div>
</ng-template>
